import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCardText,[_c('SimpleOccupationsFilter',{attrs:{"filter":_vm.filter}})],1),_c('w-data-table',{attrs:{"headers":_vm.headers,"items":_vm.occupations,"loading":_vm.loading,"sort-by":"name","show-select":"","disable-pagination":"","fixed-header":"","height":"500"},scopedSlots:_vm._u([{key:"item.code",fn:function(ref){
var item = ref.item;
return [_c('w-chip',{attrs:{"text":item.code}})]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"bold":"","text":item.name}})]}},{key:"item.categoryName",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.categoryFullName}})]}}],null,true),model:{value:(_vm.selectedOccupation),callback:function ($$v) {_vm.selectedOccupation=$$v},expression:"selectedOccupation"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }